import React from "react";
const translations = {
  en: {
    home: "Home", discover: "Discover", inbox: "Inbox", profile: "Profile",
    following: "Following", iShows: "iShows", signIn: "Sign In", signUp: "Sign Up",
    username: "Username", password: "Password", noAccount: "No account?",
    haveAccount: "Have an account?", upload: "Upload", save: "Save", gift: "Gift",
    comments: "Comments", noComments: "No comments yet. Be first!",
    addComment: "Add a comment...", post: "Post", follow: "Follow",
    following_btn: "Following", wallet: "My Wallet", balance: "Available Balance",
    withdraw: "Withdraw", transfer: "Transfer", earnedPoints: "Earned Points",
    receivedPoints: "Received Points", editProfile: "Edit Profile",
    deleteVideos: "Delete Videos", logout: "Logout", videos: "Videos",
    favourites: "Favourites", liked: "Liked", about: "About",
    contact: "Contact Us", privacy: "Privacy Policy", terms: "Terms of Service",
    signInAccount: "Sign in to your account", createAccount: "Create your account",
    copyLink: "Copy Link", repost: "Repost on IcingShow", cancel: "Cancel",
    noVideos: "No videos yet", uploadFirst: "Upload First Video",
    messages: "Messages", myWallet: "My Wallet",
  },
  fr: {
    home: "Accueil", discover: "Découvrir", inbox: "Messages", profile: "Profil",
    following: "Abonnements", iShows: "iShows", signIn: "Se connecter", signUp: "S'inscrire",
    username: "Nom d'utilisateur", password: "Mot de passe", noAccount: "Pas de compte?",
    haveAccount: "Déjà un compte?", upload: "Télécharger", save: "Sauvegarder", gift: "Cadeau",
    comments: "Commentaires", noComments: "Pas encore de commentaires. Soyez le premier!",
    addComment: "Ajouter un commentaire...", post: "Publier", follow: "Suivre",
    following_btn: "Abonné", wallet: "Mon Portefeuille", balance: "Solde disponible",
    withdraw: "Retirer", transfer: "Transférer", earnedPoints: "Points gagnés",
    receivedPoints: "Points reçus", editProfile: "Modifier le profil",
    deleteVideos: "Supprimer des vidéos", logout: "Déconnexion", videos: "Vidéos",
    favourites: "Favoris", liked: "Aimé", about: "À propos",
    contact: "Nous contacter", privacy: "Politique de confidentialité", terms: "Conditions d'utilisation",
    signInAccount: "Connectez-vous à votre compte", createAccount: "Créer votre compte",
    copyLink: "Copier le lien", repost: "Republier sur IcingShow", cancel: "Annuler",
    noVideos: "Pas encore de vidéos", uploadFirst: "Télécharger la première vidéo",
    messages: "Messages", myWallet: "Mon Portefeuille",
  },
  es: {
    home: "Inicio", discover: "Descubrir", inbox: "Bandeja", profile: "Perfil",
    following: "Siguiendo", iShows: "iShows", signIn: "Iniciar sesión", signUp: "Registrarse",
    username: "Usuario", password: "Contraseña", noAccount: "¿No tienes cuenta?",
    haveAccount: "¿Ya tienes cuenta?", upload: "Subir", save: "Guardar", gift: "Regalo",
    comments: "Comentarios", noComments: "Aún no hay comentarios. ¡Sé el primero!",
    addComment: "Añadir un comentario...", post: "Publicar", follow: "Seguir",
    following_btn: "Siguiendo", wallet: "Mi Cartera", balance: "Saldo disponible",
    withdraw: "Retirar", transfer: "Transferir", earnedPoints: "Puntos ganados",
    receivedPoints: "Puntos recibidos", editProfile: "Editar perfil",
    deleteVideos: "Eliminar videos", logout: "Cerrar sesión", videos: "Videos",
    favourites: "Favoritos", liked: "Me gusta", about: "Acerca de",
    contact: "Contáctenos", privacy: "Política de privacidad", terms: "Términos de servicio",
    signInAccount: "Inicia sesión en tu cuenta", createAccount: "Crea tu cuenta",
    copyLink: "Copiar enlace", repost: "Repostear en IcingShow", cancel: "Cancelar",
    noVideos: "No hay videos aún", uploadFirst: "Subir primer video",
    messages: "Mensajes", myWallet: "Mi Cartera",
  },
  de: {
    home: "Startseite", discover: "Entdecken", inbox: "Posteingang", profile: "Profil",
    following: "Folge ich", iShows: "iShows", signIn: "Anmelden", signUp: "Registrieren",
    username: "Benutzername", password: "Passwort", noAccount: "Kein Konto?",
    haveAccount: "Bereits ein Konto?", upload: "Hochladen", save: "Speichern", gift: "Geschenk",
    comments: "Kommentare", noComments: "Noch keine Kommentare. Sei der Erste!",
    addComment: "Kommentar hinzufügen...", post: "Posten", follow: "Folgen",
    following_btn: "Folge ich", wallet: "Meine Brieftasche", balance: "Verfügbares Guthaben",
    withdraw: "Abheben", transfer: "Übertragen", earnedPoints: "Verdiente Punkte",
    receivedPoints: "Erhaltene Punkte", editProfile: "Profil bearbeiten",
    deleteVideos: "Videos löschen", logout: "Abmelden", videos: "Videos",
    favourites: "Favoriten", liked: "Gefällt mir", about: "Über uns",
    contact: "Kontakt", privacy: "Datenschutz", terms: "Nutzungsbedingungen",
    signInAccount: "Bei Ihrem Konto anmelden", createAccount: "Konto erstellen",
    copyLink: "Link kopieren", repost: "Auf IcingShow reposten", cancel: "Abbrechen",
    noVideos: "Noch keine Videos", uploadFirst: "Erstes Video hochladen",
    messages: "Nachrichten", myWallet: "Meine Brieftasche",
  },
  ru: {
    home: "Главная", discover: "Открыть", inbox: "Входящие", profile: "Профиль",
    following: "Подписки", iShows: "iShows", signIn: "Войти", signUp: "Регистрация",
    username: "Имя пользователя", password: "Пароль", noAccount: "Нет аккаунта?",
    haveAccount: "Уже есть аккаунт?", upload: "Загрузить", save: "Сохранить", gift: "Подарок",
    comments: "Комментарии", noComments: "Пока нет комментариев. Будьте первым!",
    addComment: "Добавить комментарий...", post: "Опубликовать", follow: "Подписаться",
    following_btn: "Подписан", wallet: "Мой кошелёк", balance: "Доступный баланс",
    withdraw: "Вывести", transfer: "Перевести", earnedPoints: "Заработанные очки",
    receivedPoints: "Полученные очки", editProfile: "Редактировать профиль",
    deleteVideos: "Удалить видео", logout: "Выйти", videos: "Видео",
    favourites: "Избранное", liked: "Понравилось", about: "О нас",
    contact: "Связаться", privacy: "Конфиденциальность", terms: "Условия использования",
    signInAccount: "Войдите в свой аккаунт", createAccount: "Создать аккаунт",
    copyLink: "Копировать ссылку", repost: "Репост на IcingShow", cancel: "Отмена",
    noVideos: "Видео пока нет", uploadFirst: "Загрузить первое видео",
    messages: "Сообщения", myWallet: "Мой кошелёк",
  },
  zh: {
    home: "首页", discover: "发现", inbox: "收件箱", profile: "个人资料",
    following: "关注中", iShows: "iShows", signIn: "登录", signUp: "注册",
    username: "用户名", password: "密码", noAccount: "没有账号?",
    haveAccount: "已有账号?", upload: "上传", save: "保存", gift: "礼物",
    comments: "评论", noComments: "暂无评论，抢先评论吧！",
    addComment: "添加评论...", post: "发布", follow: "关注",
    following_btn: "已关注", wallet: "我的钱包", balance: "可用余额",
    withdraw: "提现", transfer: "转账", earnedPoints: "赚取积分",
    receivedPoints: "收到积分", editProfile: "编辑资料",
    deleteVideos: "删除视频", logout: "退出登录", videos: "视频",
    favourites: "收藏", liked: "喜欢", about: "关于",
    contact: "联系我们", privacy: "隐私政策", terms: "服务条款",
    signInAccount: "登录您的账号", createAccount: "创建账号",
    copyLink: "复制链接", repost: "在IcingShow转发", cancel: "取消",
    noVideos: "暂无视频", uploadFirst: "上传第一个视频",
    messages: "消息", myWallet: "我的钱包",
  },
  ar: {
    home: "الرئيسية", discover: "اكتشف", inbox: "البريد الوارد", profile: "الملف الشخصي",
    following: "المتابَعون", iShows: "iShows", signIn: "تسجيل الدخول", signUp: "إنشاء حساب",
    username: "اسم المستخدم", password: "كلمة المرور", noAccount: "ليس لديك حساب؟",
    haveAccount: "لديك حساب بالفعل؟", upload: "رفع", save: "حفظ", gift: "هدية",
    comments: "التعليقات", noComments: "لا توجد تعليقات بعد. كن أول من يعلق!",
    addComment: "أضف تعليقاً...", post: "نشر", follow: "متابعة",
    following_btn: "تتابع", wallet: "محفظتي", balance: "الرصيد المتاح",
    withdraw: "سحب", transfer: "تحويل", earnedPoints: "النقاط المكتسبة",
    receivedPoints: "النقاط المستلمة", editProfile: "تعديل الملف الشخصي",
    deleteVideos: "حذف الفيديوهات", logout: "تسجيل الخروج", videos: "الفيديوهات",
    favourites: "المفضلة", liked: "الإعجابات", about: "من نحن",
    contact: "اتصل بنا", privacy: "سياسة الخصوصية", terms: "شروط الخدمة",
    signInAccount: "تسجيل الدخول إلى حسابك", createAccount: "إنشاء حسابك",
    copyLink: "نسخ الرابط", repost: "إعادة نشر على IcingShow", cancel: "إلغاء",
    noVideos: "لا توجد فيديوهات بعد", uploadFirst: "رفع أول فيديو",
    messages: "الرسائل", myWallet: "محفظتي",
  },
  fa: {
    home: "خانه", discover: "کشف", inbox: "صندوق ورودی", profile: "پروفایل",
    following: "دنبال‌شوندگان", iShows: "iShows", signIn: "ورود", signUp: "ثبت‌نام",
    username: "نام کاربری", password: "رمز عبور", noAccount: "حساب ندارید؟",
    haveAccount: "حساب دارید؟", upload: "آپلود", save: "ذخیره", gift: "هدیه",
    comments: "نظرات", noComments: "هنوز نظری نیست. اولین باشید!",
    addComment: "نظر بگذارید...", post: "ارسال", follow: "دنبال کردن",
    following_btn: "دنبال می‌کنید", wallet: "کیف پول من", balance: "موجودی موجود",
    withdraw: "برداشت", transfer: "انتقال", earnedPoints: "امتیازات کسب‌شده",
    receivedPoints: "امتیازات دریافت‌شده", editProfile: "ویرایش پروفایل",
    deleteVideos: "حذف ویدیوها", logout: "خروج", videos: "ویدیوها",
    favourites: "موردعلاقه‌ها", liked: "پسندیده‌ها", about: "درباره ما",
    contact: "تماس با ما", privacy: "حریم خصوصی", terms: "شرایط خدمات",
    signInAccount: "وارد حساب خود شوید", createAccount: "حساب خود را بسازید",
    copyLink: "کپی لینک", repost: "بازنشر در IcingShow", cancel: "لغو",
    noVideos: "هنوز ویدیویی نیست", uploadFirst: "اولین ویدیو را آپلود کنید",
    messages: "پیام‌ها", myWallet: "کیف پول من",
  },
  ja: {
    home: "ホーム", discover: "発見", inbox: "受信箱", profile: "プロフィール",
    following: "フォロー中", iShows: "iShows", signIn: "ログイン", signUp: "登録",
    username: "ユーザー名", password: "パスワード", noAccount: "アカウントをお持ちでない方",
    haveAccount: "すでにアカウントをお持ちですか？", upload: "アップロード", save: "保存", gift: "ギフト",
    comments: "コメント", noComments: "まだコメントはありません。最初にコメントしよう！",
    addComment: "コメントを追加...", post: "投稿", follow: "フォロー",
    following_btn: "フォロー中", wallet: "ウォレット", balance: "利用可能残高",
    withdraw: "引き出す", transfer: "送金", earnedPoints: "獲得ポイント",
    receivedPoints: "受取ポイント", editProfile: "プロフィール編集",
    deleteVideos: "動画を削除", logout: "ログアウト", videos: "動画",
    favourites: "お気に入り", liked: "いいね", about: "会社概要",
    contact: "お問い合わせ", privacy: "プライバシーポリシー", terms: "利用規約",
    signInAccount: "アカウントにサインイン", createAccount: "アカウントを作成",
    copyLink: "リンクをコピー", repost: "IcingShowでリポスト", cancel: "キャンセル",
    noVideos: "動画はまだありません", uploadFirst: "最初の動画をアップロード",
    messages: "メッセージ", myWallet: "ウォレット",
  },
};

// Plain getter — used for one-off reads
export function t(key) {
  const lang = localStorage.getItem("icing_lang") || "en";
  const dict = translations[lang] || translations["en"];
  return dict[key] || translations["en"][key] || key;
}

// React hook — re-renders the calling component when language changes
export function useLang() {
  const [lang, setLang] = React.useState(localStorage.getItem("icing_lang") || "en");
  React.useEffect(() => {
    const handler = () => setLang(localStorage.getItem("icing_lang") || "en");
    window.addEventListener("icing_lang_change", handler);
    return () => window.removeEventListener("icing_lang_change", handler);
  }, []);
  const tr = (key) => {
    const dict = translations[lang] || translations["en"];
    return dict[key] || translations["en"][key] || key;
  };
  return { lang, t: tr };
}

export default translations;
